<template>
    <div
        :class="appearance === 'black' ? 'fin-bg-stone-900 fin-p-5 fin-text-white fin-flex-1' : 'fin-bg-white fin-p-5 fin-text-black fin-flex-1'">
        <div class="fin-flex fin-items-center fin-justify-between fin-mb-3" v-if="!header_hidden">
            <div class="fin-flex fin-flex-col fin-space-y-4">
                <img :src="logo" width="100" height="100"/>
            </div>

            <div class="fin-flex fin-justify-between fin-items-center">
                <el-badge
                    :value="notificationCount"
                    :max="99"
                    :hidden="notificationCount === 0"
                    class="item mr-4"
                >
                    <i class="el-icon-message el-button el-button--default el-button--small is-circle"></i>
                </el-badge>

                <small class="fin-uppercase fin-font-bold"
                       :class="appearance === 'black' ? 'fin-text-white' : 'fin-text-black'">
                    {{ date }}
                </small>
            </div>
        </div>

        <grid-layout
            v-if="dashboard_view === 'totals'"
            :layout.sync="cards"
            :col-num="24"
            :row-height="25"
            :is-draggable="true"
            :is-resizable="true"
            :is-mirrored="false"
            :vertical-compact="true"
            :margin="[10, 10]"
            :use-css-transforms="true"
        >
            <grid-item
                v-for="item in cards"
                :x.sync="item.x"
                :y.sync="item.y"
                :w.sync="item.w"
                :h.sync="item.h"
                :i="item.i"
                :key="item.i"
                @resize="updateWidgetSize"
                @move="moveEvent"
                v-if="checkWidgets(item.parentId)"
            >
                <component
                    :is="item.component"
                    :ref="item.ref"
                    v-bind="item.props"
                    v-bind:appearance="appearance"
                    v-bind:tenant-id="tenantId"
                    v-bind:dashboard-id="dashboard.id"
                    :class="appearance === 'black' ? 'component-white' : 'component-black'"
                >
                </component>
            </grid-item>
        </grid-layout>

        <draggable
            v-if="dashboard_view === 'charts'"
            :list="computedWidgets"
            group="dashboard"
            @end="onDragEnd"
            :options="{handle: '.move'}"
            class="card-columns">
            <div v-for="(item, index) in computedWidgets" class="card"
                 v-if="checkWidgets(item.id)" :id="checkWidgets(item.id)"
                 :key="item.order">
                <component
                    :is="checkWidgets(item.component)"
                    :ref="item.ref"
                    v-bind="item.props"
                    v-bind:appearance="appearance"
                    v-bind:tenant-id="tenantId"
                    v-bind:dashboard-id="dashboard.id"
                    :class="appearance === 'black' ? 'component-white' : 'component-black'"
                >
                </component>
            </div>
        </draggable>

        <div class="d-flex align-items-center justify-content-center">
            <dashboard-carousel
                v-show="dashboard_view === 'carousels'"
                v-bind:appearance="appearance"
                v-bind:tenant-id="tenantId"
                v-bind:dashboard="dashboard"
                v-bind:selected-widgets="selectedWidgets"
                class="px-2 w-100"
            >
            </dashboard-carousel>
        </div>

        <settlements-chart
            v-show="dashboard_view === 'settlements'"
            v-bind:appearance="appearance"
            v-bind:tenant-id="tenantId"
            v-bind:dashboard-id="_.get(dashboard, 'id')"
            class="fin-px-2 fin-w-100"
        />

        <broker-breakdowns
            v-show="dashboard_view === 'broker-breakdowns'"
            v-bind:appearance="appearance"
            v-bind:tenant-id="tenantId"
            v-bind:dashboard-id="_.get(dashboard, 'id')"
            class="fin-px-2 fin-w-100"
        />
    </div>
</template>

<script>
import SubmissionsChart from "./SubmissionsChart";
import SettledChart from "./SetteledChart";
import LeadSettlementChart from "./LeadSettlementChart";
import BrokerSettledChart from "./BrokerSettledChart";
import BrokerNafChart from "./BrokerNafChart";
import BrokerIncomeChart from "./BrokerIncomeChart";
import LenderIncomeChart from "./LenderIncomeChart";
import LenderSettledChart from "./LenderSettledChart";
import LenderNafChart from "./LenderNafChart";
import TeamNafChart from "./TeamNafChart";
import TeamIncomeChart from "./TeamIncomeChart";
import TeamSettledChart from "./TeamSettledChart";
import ActivityChart from "./ActivityChart";
import AverageIncomeChart from "./AverageIncomeChart";
import TotalIncomeChart from "./TotalIncomeChart";
import ClosedApplicationChart from "./ClosedApplicationChart";
import draggable from "vuedraggable";
import VueGridLayout from 'vue-grid-layout'
import cards from "./card-totals/cards.json"
import AverageIncomeCard from "./card-totals/AverageIncomeCard";
import SettledCard from "./card-totals/SetteledCard";
import BrokerIncomeCard from "./card-totals/BrokerIncomeCard";
import BrokerNafCard from "./card-totals/BrokerNafCard";
import BrokerSettledCard from "./card-totals/BrokerSettledCard";
import closedApplicationCard from "./card-totals/ClosedApplicationCard";
import LenderIncomeCard from "./card-totals/LenderIncomeCard";
import LenderNafCard from "./card-totals/LenderNafCard";
import LenderSettledCard from "./card-totals/LenderSettledCard";
import SubmissionsCard from "./card-totals/SubmissionsCard";
import TeamIncomeCard from "./card-totals/TeamIncomeCard";
import TeamNafCard from "./card-totals/TeamNafCard";
import TeamSettledCard from "./card-totals/TeamSettledCard";
import TotalIncomeCard from "./card-totals/TotalIncomeCard";
import dashboardCarousel from "./slider/DashboardCarousel";
import Settlements from "./Settlements";
import DisplayMultipleDashboards from "./DashboardViews/DisplayMultipleDashboards";
import SettlementsChart from "./SettlementsChart";
import BrokerBreakdowns from "./BrokerBreakdowns";

export default {
    name: 'AdminDashboardIndex',
    props: [
        'tenantId',
        'dashboard'
    ],
    components: {
        "submissions-chart": SubmissionsChart,
        "settled-chart": SettledChart,
        "lead-settlement-chart": LeadSettlementChart,
        "broker-settled-chart": BrokerSettledChart,
        "broker-naf-chart": BrokerNafChart,
        "broker-income-chart": BrokerIncomeChart,
        "lender-income-chart": LenderIncomeChart,
        "lender-settled-chart": LenderSettledChart,
        "lender-naf-chart": LenderNafChart,
        "team-settled-chart": TeamSettledChart,
        "team-income-chart": TeamIncomeChart,
        "team-naf-chart": TeamNafChart,
        "activity-chart": ActivityChart,
        "average-income-chart": AverageIncomeChart,
        "total-income-chart": TotalIncomeChart,
        "closed-application-chart": ClosedApplicationChart,
        "average-income-card": AverageIncomeCard,
        "settled-card": SettledCard,
        "broker-income-card": BrokerIncomeCard,
        "broker-naf-card": BrokerNafCard,
        "broker-settled-card": BrokerSettledCard,
        "closed-application-card": closedApplicationCard,
        "lender-income-card": LenderIncomeCard,
        "lender-naf-card": LenderNafCard,
        "lender-settled-card": LenderSettledCard,
        "submissions-card": SubmissionsCard,
        "team-income-card": TeamIncomeCard,
        "team-naf-card": TeamNafCard,
        "team-settled-card": TeamSettledCard,
        "total-income-card": TotalIncomeCard,
        draggable,
        GridLayout: VueGridLayout.GridLayout,
        GridItem: VueGridLayout.GridItem,
        "dashboard-carousel": dashboardCarousel,
        "settlements": Settlements,
        "display-multiple-dashboards": DisplayMultipleDashboards,
        "settlements-chart": SettlementsChart,
        "broker-breakdowns": BrokerBreakdowns,
    },
    data() {
        return {
            dashboardId: '',
            selectedWidgets: [],
            appearance: '',
            header_hidden: false,
            lenderSubmissions: [],
            settledHistory: [],
            statsTotal: [],
            brokerSettled: [],
            lender: [],
            teamLeaderboard: [],
            activityChart: [],
            totalIncome: [],
            averageIncome: [],
            closedApplication: [],
            dashboard_view: [],
            notificationCount: 0,
            logo: '',
            date: '',
            widgets: [
                {
                    x: 0,
                    y: 2,
                    w: 4,
                    h: 7,
                    width: "350",
                    height: "350",
                    id: "submissions-chart",
                    order: 0,
                    i: "0",
                    ref: "Submissions",
                    title: "Submissions",
                    permission: {},
                    component: "submissions-chart",
                    props: {}
                },
                {
                    x: 2,
                    y: 2,
                    w: 4,
                    h: 3.5,
                    width: "350",
                    height: "350",
                    id: "settled-chart",
                    order: 1,
                    i: "1",
                    ref: "settled",
                    title: "Settled",
                    permission: {},
                    component: "settled-chart",
                    props: {}
                },
                {
                    x: 4,
                    y: 2,
                    w: 4,
                    h: 8.5,
                    width: "350",
                    height: "350",
                    id: "lead-settlement-chart",
                    order: 2,
                    i: "2",
                    ref: "lead-to-settlement",
                    title: "Lead To Settlement",
                    permission: {},
                    component: "lead-settlement-chart",
                    props: {}
                },
                {
                    x: 6,
                    y: 2,
                    w: 4,
                    h: 6.5,
                    width: "350",
                    height: "350",
                    id: "broker-settled-chart",
                    order: 3,
                    i: "3",
                    ref: "broker-settled-chart",
                    title: "Broker Settled Leaderboards",
                    permission: {},
                    component: "broker-settled-chart",
                    props: {}
                },
                {
                    x: 8,
                    y: 2,
                    w: 4,
                    h: 6.5,
                    width: "350",
                    height: "350",
                    id: "broker-naf-chart",
                    order: 4,
                    i: "4",
                    ref: "broker-naf-chart",
                    title: "Broker Naf Leaderboards",
                    permission: {},
                    component: "broker-naf-chart",
                    props: {}
                },
                {
                    x: 10,
                    y: 2,
                    w: 4,
                    h: 6.5,
                    width: "350",
                    height: "350",
                    id: "broker-income-chart",
                    order: 5,
                    i: "5",
                    ref: "broker-income-chart",
                    title: "Broker Income Leaderboards",
                    permission: {},
                    component: "broker-income-chart",
                    props: {}
                },
                {
                    x: 0,
                    y: 2,
                    w: 4,
                    h: 8,
                    width: "350",
                    height: "350",
                    id: "lender-naf-chart",
                    order: 6,
                    i: "6",
                    ref: "lender-naf-chart",
                    title: "Lender Naf Leaderboard",
                    permission: {},
                    component: "lender-naf-chart",
                    props: {}
                },
                {
                    x: 2,
                    y: 2,
                    w: 4,
                    h: 8,
                    width: "350",
                    height: "350",
                    id: "lender-settled-chart",
                    order: 7,
                    i: "7",
                    ref: "lender-settled-chart",
                    title: "Lender Settled Leaderboard",
                    permission: {},
                    component: "lender-settled-chart",
                    props: {}
                },
                {
                    x: 4,
                    y: 2,
                    w: 4,
                    h: 8,
                    width: "350",
                    height: "350",
                    id: "lender-income-chart",
                    order: 8,
                    i: "8",
                    ref: "lender-income-chart",
                    title: "Lender Income Leaderboard",
                    permission: {},
                    component: "lender-income-chart",
                    props: {}
                },
                {
                    x: 6,
                    y: 2,
                    w: 4,
                    h: 4.5,
                    width: "350",
                    height: "350",
                    id: "team-naf-chart",
                    order: 9,
                    i: "9",
                    ref: "team-naf-chart",
                    title: "Team Naf Leaderboard",
                    permission: {},
                    component: "team-naf-chart",
                    props: {}
                },
                {
                    x: 8,
                    y: 2,
                    w: 4,
                    h: 4.5,
                    width: "350",
                    height: "350",
                    id: "team-income-chart",
                    order: 10,
                    i: "10",
                    ref: "team-income-chart",
                    title: "Team Income Leaderboard",
                    permission: {},
                    component: "team-income-chart",
                    props: {}
                },
                {
                    x: 10,
                    y: 2,
                    w: 4,
                    h: 4.5,
                    width: "350",
                    height: "350",
                    id: "team-settled-chart",
                    order: 11,
                    i: "11",
                    ref: "team-settled-chart",
                    title: "Team Settled Leaderboard",
                    permission: {},
                    component: "team-settled-chart",
                    props: {}
                },
                {
                    x: 0,
                    y: 2,
                    w: 4,
                    h: 8.5,
                    width: "350",
                    height: "350",
                    id: "activity-chart",
                    order: 12,
                    i: "12",
                    ref: "activity-chart",
                    title: "Activity",
                    permission: {},
                    component: "activity-chart",
                    props: {}
                },
                {
                    x: 2,
                    y: 2,
                    w: 4,
                    h: 7.5,
                    width: "350",
                    height: "350",
                    id: "total-income-chart",
                    order: 13,
                    i: "13",
                    ref: "total-income-chart",
                    title: "Total income",
                    permission: {},
                    component: "total-income-chart",
                    props: {}
                },
                {
                    x: 4,
                    y: 2,
                    w: 4,
                    h: 6,
                    width: "350",
                    height: "350",
                    id: "average-income-chart",
                    order: 14,
                    i: "14",
                    ref: "average-income-chart",
                    title: "Average income",
                    permission: {},
                    component: "average-income-chart",
                    props: {}
                },
                {
                    x: 6,
                    y: 2,
                    w: 4,
                    h: 8,
                    width: "350",
                    height: "350",
                    id: "closed-application-chart",
                    order: 15,
                    i: "15",
                    ref: "closed-application-chart",
                    title: "Closed Applications",
                    permission: {},
                    component: "closed-application-chart",
                    props: {}
                },
                {
                    x: 8,
                    y: 2,
                    w: 4,
                    h: 10,
                    width: "350",
                    height: "350",
                    id: "settlements",
                    order: 16,
                    i: "16",
                    ref: "settlements",
                    title: "Settlements",
                    permission: {},
                    component: "settlements",
                    props: {}
                }
            ],
            cards: cards,
            height: '',
            sortingArray: [
                {id: "submissions-chart", order: 0},
                {id: "settled-chart", order: 1},
                {id: "lead-settlement-chart", order: 2},
                {id: "broker-settled-chart", order: 3},
                {id: "broker-naf-chart", order: 4},
                {id: "broker-income-chart", order: 5},
                {id: "lender-naf-chart", order: 6},
                {id: "lender-settled-chart", order: 7},
                {id: "lender-income-chart", order: 8},
                {id: "team-naf-chart", order: 9},
                {id: "team-income-chart", order: 10},
                {id: "team-settled-chart", order: 11},
                {id: "activity-chart", order: 12},
                {id: "total-income-chart", order: 13},
                {id: "average-income-chart", order: 14},
                {id: "closed-application-chart", order: 15},
                {id: "settlements", order: 16},
            ]
        }
    },
    beforeMount() {
        this.dashboardWidgets()
    },
    mounted() {
        this.selectedWidgets = JSON.parse(this.dashboard.selected_widgets)
        this.dashboardId = this.dashboard.id
        this.appearance = this.dashboard.theme
        this.dashboard_view = this.dashboard.dashboard_view
        this.sortingArray = JSON.parse(this.dashboard.widgets_order)
        this.sorted()

        this.dashboardWidgets()

        // poll every minute
        this.dashboardPollWidgetsData()

        Echo.private(`dashboard.${this.tenantId}.${window.DashboardID}`).listen(".dashboard-live", (event) => {
            this.lenderSubmissions = event.lenderSubmissions.lenderSubmissions
            this.settledHistory = event.settledDeal.settledHistory
            this.statsTotal = event.leadToSettlement.leadToSettlement.statsTotal
            this.brokerSettled = event.brokerSettlement.settlements
            this.lender = event.lenderLeaderboard.lender
            this.teamLeaderboard = event.teamLeaderboards.teamLeaderboards
            this.activityChart = event.pipeline.pipeline
            this.totalIncome = event.totalIncome.totalIncome
            this.averageIncome = event.avgIncome.averageIncome
            this.date = event.date
            this.logo = event.logo
            this.header_hidden = event.dashboardHidden
            this.appearance = event.appearance.theme
            this.selectedWidgets = JSON.parse(event.selectedWidgets)
            this.dashboard_view = event.dashboardView
            this.dashboardId = event.dashboardId
            this.notificationCount = event.emailNotifications
            this.widgets.permission = event.lenderSubmissions.lenderSubmissions
            this.sortingArray = JSON.parse(event.dashboardWidgetsOrder)
            this.closedApplication = event.closedApplication.closedApplication
        })
    },
    computed: {
        submissionsData() {
            return this.lenderSubmissions
        },
        computedWidgets() {
            return this.widgets
        },
    },
    created() {
        Echo.private(`dashboard.${this.tenantId}.${window.DashboardID}`).listen(".dashboard-live", (event) => {
            this.lenderSubmissions = event.lenderSubmissions.lenderSubmissions
            this.settledHistory = event.settledDeal.settledHistory
            this.statsTotal = event.leadToSettlement.leadToSettlement.statsTotal
            this.brokerSettled = event.brokerSettlement.settlements
            this.lender = event.lenderLeaderboard.lender
            this.teamLeaderboard = event.teamLeaderboards.teamLeaderboards
            this.activityChart = event.pipeline.pipeline
            this.totalIncome = event.totalIncome.totalIncome
            this.averageIncome = event.avgIncome.averageIncome
            this.date = event.date
            this.logo = event.logo
            this.header_hidden = event.dashboardHidden
            this.appearance = event.appearance.theme
            this.selectedWidgets = event.selectedWidgets ? JSON.parse(event.selectedWidgets) : []
            this.dashboard_view = event.dashboardView
            this.dashboardId = event.dashboardId
            this.notificationCount = event.emailNotifications
            this.widgets.permission = event.lenderSubmissions.lenderSubmissions
            this.closedApplication = event.closedApplication.closedApplication
            this.sortingArray = event.dashboardWidgetsOrder ? JSON.parse(event.dashboardWidgetsOrder) : []

            this.checkWidgets
        })
    },
    destroyed() {
        Echo.leave(`dashboard.${this.tenantId}.${window.DashboardID}`)
    },
    methods: {
        moveEvent: function (i, newX, newY) {
            var p;
            for (p = 0; p < this.cards.length; p++) {
                //Horizontal swapping
                if (
                    newX >= this.cards[p]["x"] &&
                    newX < this.cards[p]["x"] + this.cards[p]["w"] &&
                    this.cards[i]["y"] == this.cards[p]["y"] &&
                    i != this.cards[p]["i"]
                ) {
                    let initialX = this.cards[i]["x"];
                    let finalX = this.cards[p]["x"];
                    this.cards[i]["x"] = finalX;
                    this.cards[p]["x"] = initialX;
                }
                //Vertical swapping
                if (
                    newY >= this.cards[p]["y"] &&
                    newY < this.cards[p]["y"] + 1 &&
                    this.cards[i]["x"] == this.cards[p]["x"] &&
                    i != this.cards[p]["i"]
                ) {
                    let initialY = this.cards[i]["y"];
                    let finalY = this.cards[p]["y"];
                    this.cards[i]["y"] = finalY;
                    this.cards[p]["y"] = initialY;
                }
            }
        },
        dashboardWidgets() {
            axios.get("/admin/settings/dashboard/" + window.DashboardID + "/widgets").then()
        },
        dashboardPollWidgetsData() {
            setInterval(function () {
                axios.get("/admin/settings/dashboard/" + window.DashboardID + "/widgets").then()
            }.bind(this), 300000)
        },
        updateWidgetSize: function (i, newH, newW, newHPx, newWPx) {
            const index = this.cards.map((widget) => widget.eui).indexOf(i)

            this.cards[index] = Object.assign(this.cards[index], {
                w: newW,
                width: newW,
                h: newH,
                height: newH
            })
        },
        onDragEnd() {
            let newSortingArray = this.widgets.map((item, index) => ({id: item.id, order: index}))
            axios.post("/admin/settings/dashboard/" + window.DashboardID + "/order", {
                'widgets_order': newSortingArray
            })
                .then(res => {
                    console.log(res)
                    this.sortingArray = res.data
                }).finally(() => {
                this.sorted()
            })
        },
        sorted() {
            this.widgets = this.widgets.sort((a, b) => {
                return _.get(_.find(this.sortingArray, {id: a.id}), 'order') - _.get(_.find(this.sortingArray, {id: b.id}), 'order');
            })
        },
        checkWidgets(id) {
            let getWidgetIds = this.selectedWidgets.filter(function (elem) {
                if (_.get(elem, 'id') == id) return elem
            })

            return this.selectedWidgets && this.selectedWidgets.length > 0 ? _.map(getWidgetIds, function getId(w) {
                return w.id
            }).toString() : id
        }
    }
}

</script>

<style lang="scss" scoped>
.vue-grid-height {
    height: 100%;
}

.theme {
    background-color: #ffffff;
    color: #0a1520;
    padding: 25px;
    height: 100%;

    .title {
        color: #000;
        text-transform: uppercase;
        font-weight: bold;
        font-size: 20px;
    }

    .date {
        color: #000;
        text-transform: uppercase;
        font-weight: bold;
    }
}

.black {
    background-color: #0a1520;
    color: #0b93f6;
    padding: 25px;

    .title {
        color: #fff;
        text-transform: uppercase;
        font-weight: bold;
        font-size: 20px;
    }

    .date {
        color: #fff;
        text-transform: uppercase;
        font-weight: bold;
    }
}

.component-white .white {
    background-color: rgba(255, 255, 255, 0.5);
}

.component-black .black {
    background-color: rgba(black, 0.5);
}

.white {
    background-color: #ffffff;
    color: #0a1520;
    padding: 25px;

    .title {
        color: #000;
        text-transform: uppercase;
        font-weight: bold;
        font-size: 20px;
    }

    .date {
        color: #000;
        text-transform: uppercase;
        font-weight: bold;
    }
}

.move {
    cursor: move;
}

.vue-grid-layout {
    height: 100%;
}

.vue-grid-item .resizing {
    opacity: 0.9;
}

.vue-grid-item .no-drag {
    height: 100%;
    width: 100%;
}

.vue-grid-item .minMax {
    font-size: 12px;
}

.vue-grid-item .add {
    cursor: pointer;
}

.vue-draggable-handle {
    position: absolute;
    width: 20px;
    height: 20px;
    top: 0;
    left: 0;
    background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='10'><circle cx='5' cy='5' r='5' fill='#999999'/></svg>") no-repeat;
    background-position: bottom right;
    padding: 0 8px 8px 0;
    background-repeat: no-repeat;
    background-origin: content-box;
    box-sizing: border-box;
    cursor: pointer;
}

@media (min-width: 576px) {
    .card-columns {
        column-count: 2;
    }
}

@media (min-width: 768px) {
    .card-columns {
        column-count: 3;
    }
}

@media (min-width: 992px) {
    .card-columns {
        column-count: 4;
    }
}

@media (min-width: 1200px) {
    .card-columns {
        column-count: 4;
    }
}
</style>
